module.exports = __webpack_public_path__ + "static/media/programacao.b220d929.svg";